






















import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { IShippingMethod } from '@/models'
import { STORE_MODULES, ACTIONS_ORDER } from '@/enums'
import { BaseShippingMethodListItem } from '@/components'
import { IParcel } from './models'
import { DialogSelectParcel } from './components'
import cloneDeep from 'lodash/cloneDeep'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)
const LOCAL_STORAGE_PARCEL_KEY = 'cached-parcel'
const LOCAL_STORAGE_PARCEL_EXPIRATION_TS_KEY = 'cached-parcel-expiration-ts'
const EXPIRATION_TIME_MS = 30 * 864e5 // month

export default Vue.extend({
    name: 'ShippingMethodListItemInpostParcel',

    components: { BaseShippingMethodListItem, DialogSelectParcel },

    model: {
        prop: 'isRequestInProgress',
        event: 'update:is-request-in-progress',
    },

    props: {
        method: {
            type: Object as () => IShippingMethod,
            required: true,
        },
        isRequestInProgress: {
            type: Boolean,
            required: true,
        },
    },

    data: () => ({
        isRequestInProgressInternal: false,
        isDialogSelectParcelShown: false,
        parcel: undefined as undefined | IParcel,
    }),

    watch: {
        isRequestInProgressInternal(isInProgress: boolean) {
            this.$emit('update:is-request-in-progress', isInProgress)
        },
    },

    created() {
        this.parcel = this.getCachedParcel()
    },

    methods: {
        ...mapActions({ createAndSetShipping: ACTIONS_ORDER.CREATE_AND_SET_SHIPPING }),

        selectParcelOrCreateShipping() {
            if (this.parcel) {
                this.createShipping()
            } else {
                this.selectParcel()
            }
        },

        selectParcel() {
            this.isDialogSelectParcelShown = true
        },

        async createShipping(): Promise<void> {
            if (!this.parcel) return

            this.isRequestInProgressInternal = true

            try {
                const method = cloneDeep(this.method)
                const field = method.fields.find(({ name }) => name === 'shipx_point_name')!

                field.value = this.parcel.name

                await this.createAndSetShipping(method)
                this.cacheParcel(this.parcel)
            } catch (error) {}

            this.isRequestInProgressInternal = false
        },

        cacheParcel(parcel: IParcel) {
            if (this.getCachedParcel?.name === parcel.name) return

            localStorage.setItem(LOCAL_STORAGE_PARCEL_KEY, JSON.stringify(parcel))
            localStorage.setItem(
                LOCAL_STORAGE_PARCEL_EXPIRATION_TS_KEY,
                (Date.now() + EXPIRATION_TIME_MS).toString()
            )
        },

        getCachedParcel(): IParcel | undefined {
            const expirationTimestamp = localStorage.getItem(
                LOCAL_STORAGE_PARCEL_EXPIRATION_TS_KEY
            )
            const parcel = localStorage.getItem(LOCAL_STORAGE_PARCEL_KEY)

            if (expirationTimestamp && parseInt(expirationTimestamp) > Date.now() && parcel) {
                return JSON.parse(parcel)
            }

            localStorage.removeItem(LOCAL_STORAGE_PARCEL_KEY)
            localStorage.removeItem(LOCAL_STORAGE_PARCEL_EXPIRATION_TS_KEY)
        },
    },
})
